import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Avatar,
  Card,
  CardContent,
  Input,
  CircularProgress,
  Tabs,
  Tab,
  MenuItem,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../../AuthProvider';
import { useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
function StudentUpdateDetails() {
  const { empId ,studentId} = useParams();
//   console.log("I AM EMPLOYEE ID :"+empId);
  const [employee, setEmployee] = useState('');
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  const [student, setStudent] = useState('');
  const [isEditing, setIsEditing] = useState({ 0: false, 1: false, 2: false, 3: false });
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  // const studentId = location.state?.studentId; // Access the passed data

  // SSC states
  const [sscClassSectionData, setSscClassSectionData] = useState([]);

  const [sscSectionOptions, setSscSectionOptions] = useState([]);

  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const { pId,oId ,board} = useAuth();
    
  console.log ("student:"+studentId);
const { state } = useLocation();
  const principalId = state?.PrincipalId;
  const PrincipalId = pId || principalId;

  const [buttonLoader, setButtonLoader] = useState(false);  // State for button loader
  const [studentData, setStudentData] = useState({

    //Basic Details
    // prefix: '',
    firstName: '',
    lastName: '',
    emailId: '',
    contactNumber1: '',
    dateofBirth:'',
    // workEmail: '',
    // joiningDate: '',
    admissionDate:'',
    address:'',
    // hno: '',
    // city: '',
    // state: '',
    // bloodGroup:'',
    nationality: '',
    gender: '',
    //Personal Deatils
    // panNumber: '',
    aadharNumber: '',
    // passportNo: '',
    motherName: "",
    fatherName: "",
    fathersQualification:"",
    fathersOccupation:"",
    mothersQualification:'',
    mothersOccupation:'',

    contactNumber2: "",

    // uan: "",
    // maritalStatus: "",
    //Professional experience
    previousSchoolName: "",
    // previousExperience: "",
    // department: "",
    // designation: "",
    // currentCtc: "",
    higherQualification: "",
    //Bank details
    bankName: "",
    bankAccount: "",
    ifscCode: "",
    bankBranch: "",

    //Documents
    passPhoto: null,
    document1: null,
    document2: null,
    document3: null,
  });
  const [tabData, setTabData] = useState({
    0: {}, // Personal Information
    1: {}, // Parent Details
    2: {}, // Educational Background
    3: {}, // Admission Details
    4: {}, // Fee Details
    5: {}, // Other Details
  });
  
  const [passPhoto, setPassPhoto] = useState(null);
  const [document1, setDocument1] = useState(null);
  // const [document2, setDocument2] = useState(null);
  // const [document3, setDocument3] = useState(null);
 
  const [tabIndex, setTabIndex] = useState(0); // Manage active tab
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [empId]);

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await fetch(`${baseUrl}/api/admission/getAllStudentsDetailsStudentId/${studentId}/${oId}`);
      const data = await response.json();
      setStudent(data);
      setStudentData((prevData) => ({
        ...prevData,
        ...data
      }));
      // Initialize tab-specific data
      setTabData({
        0: { // Personal Information
          firstName: data.firstName,
          lastName: data.lastName,
          gender: data.gender,
          dateofBirth: data.dob,
          aadharNumber: data.aadharNumber,
          address: data.address,
          primaryContact: data.primaryContact,
          alternateContact: data.alternateContact,
        //   admissionDate: data.admissionDate,
          nationality: data.nationality,
          religion: data.religion,
          caste: data.caste,
        //   role: data.role,
        },
        1: { // Parent/Guardian Details
            fathersFirstName: data.fathersFirstName ,
            fathersLastName: data.fathersLastName ,
          fathersQualification: data.fathersQualification,
          fathersOccupation: data.fathersOccupation,
          fathersMailId: data.fathersMailId,
          mothersFirstName: data.mothersFirstName ,
          mothersLastName: data.mothersLastName ,
          mothersQualification: data.mothersQualification,
          mothersOccupation: data.mothersOccupation,
          mothersMailId: data.mothersMailId,
        },
        2: { // Educational Background
          previousSchool: data.previousSchool,
          course: data.course,
          romanNumberClass: data.romanNumberClass,
          sections: data.sections,
          mole1: data.mole1,
          mole2: data.mole2,
        },
        3: { // Admission Details
          studentId: data.studentId,
          customAdmissionNumber: data.customAdmissionNumber,
          studentRollNumber:data.studentRollNumber,
          studentJoinedClass:data.studentJoinedClass,
        //   admissionDate: data.admissionDate,
        //   academicYear: data.academicYear,
          studentJoinedYear: data.studentJoinedYear,
          pen: data.pen,
        //   status: data.status,
        },
        4: { // Financial Information
          tutionFee: data.tutionFee,
          admissionFee: data.admissionFee,
        },
       
        5: { // other details
            passPhoto: data.passPhoto,
            document1: data.document1,
            document2: data.document2,
            document3: data.document3,
              },
      });
      
      
    } catch (error) {
      console.error('Error fetching student:', error);
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (event) => {
  const { name, value } = event.target;

  setTabData((prevData) => ({
    ...prevData,
    [tabIndex]: {
      ...(prevData[tabIndex] || {}), // Ensure object exists
      [name]: value, // Update specific field
    },
  }));

  console.log("Updated tabData:", tabData); // Debugging output
};

  
  const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      // await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]); 

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (name === 'passPhoto') {
      setPassPhoto(files[0]);
    } else if (name === 'document1') {
      setDocument1(files[0]);
    }
    //  else if (name === 'document2') {
    //   setDocument2(files[0]);
    // } else if (name === 'document3') {
    //   setDocument3(files[0]);
    // }
  };


  

  //new handle save method
  // const handleSave = async () => {
  //   setButtonLoader(true);  // Start the button loader
  //   const dataToSend = { ...tabData[tabIndex] };
  
  //   try {
  //     if (tabIndex === 5) {
  //       await handleFileUploadAndSave();
  //     } else {
  //       await updateStudentData(dataToSend);
  //     }
  
  //     // If the data update is successful
    
  //     // Show success toast notification
  //     toast.success("Student details updated successfully!", {
  //       position: "top-right",
  //       autoClose: 1000
  //     });
  
  //   } catch (error) {
    
  //     // Show error toast notification
  //     toast.error("Failed to update student details!", {
  //       position: "top-right",
  //       autoClose: 1000
  //     });
  //   } finally {
  //     setButtonLoader(false);  // Stop the button loader
  //   }
  // };

  const handleSave = async () => {
  setButtonLoader(true); // Start the button loader
  const dataToSend = { ...tabData[tabIndex] };

  try {
    if (tabIndex === 5) {
      await handleFileUploadAndSave();
    } else {
      await updateStudentData(dataToSend);
    }

    // If the data update is successful
    toast.success("Student details updated successfully!", {
      position: "top-right",
      autoClose: 1000
    });

  } catch (error) {
    console.error("❌ Error in handleSave:", error);

    // Prefer server or thrown error message if available
    const errorMessage =
      error?.message || "Failed to update student details!";

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 3000
    });
  } finally {
    setButtonLoader(false); // Stop the button loader
  }
};

 
//   const updateStudentData = async (dataToSend) => {
//   try {
//     const formData = new FormData();
    

//     Object.entries(dataToSend).forEach(([key, value]) => {
//       if (value instanceof File) {
//         formData.append(key, value);
//       } else if (value !== undefined && value !== null) {
//         formData.append(key, String(value).trim());
//       } else {
//         formData.append(key, "");
//       }
//     });

//     console.log("📤 Data being sent to API:", dataToSend);

//     const response = await fetch(
//       `${baseUrl}/api/admission/update/allStudentsDetails/${studentId}/${oId}`,
//       {
//         method: "PATCH",
//         body: formData,
//       }
//     );

//     const responseJson = await response.json();
//     console.log("📥 Server Response:", responseJson);

//     if (response.ok) {
//       console.log("✅ Data updated successfully");
//       setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
//       fetchData(); // Reload data
//       return responseJson; // explicitly return success
//     } else {
//       console.error("❌ Update failed:", responseJson);
//       // Throw error so handleSave's catch is triggered
//       throw new Error(responseJson?.message || "Failed to update student data");
//     }
//   } catch (error) {
//     console.error("❌ Error updating student data:", error);
//     throw error; // Re-throw so handleSave catches it
//   }
// };

const updateStudentData = async (dataToSend) => {
  try {
    const formData = new FormData();

    Object.entries(dataToSend).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else if (value !== undefined && value !== null) {
        // ✅ Format dateOfBirth to DD-MM-YYYY
        if (key === "dateofBirth" && value) {
          const formattedDate = dayjs(value).format("YYYY-MM-DD");
          formData.append(key, formattedDate);
        } else {
          formData.append(key, String(value).trim());
        }
      } else {
        formData.append(key, "");
      }
    });

    console.log("📤 Data being sent to API:", Object.fromEntries(formData));

    const response = await fetch(
      `${baseUrl}/api/admission/update/allStudentsDetails/${studentId}/${oId}`,
      {
        method: "PATCH",
        body: formData,
      }
    );

    const responseJson = await response.json();
    console.log("📥 Server Response:", responseJson);

    if (response.ok) {
      console.log("✅ Data updated successfully");
      setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
      fetchData(); // Reload data
      return responseJson;
    } else {
      console.error("❌ Update failed:", responseJson);
      throw new Error(responseJson?.message || "Failed to update student data");
    }
  } catch (error) {
    console.error("❌ Error updating student data:", error);
    throw error;
  }
};
  

  
  
  

  
  const handleFileUploadAndSave = async () => {
    try {
      const formData = new FormData();
  
      // Add other fields from tabData[tabIndex] to formData
      Object.entries(tabData[tabIndex] || {}).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });
  
      // Add profile pic and documents to FormData if they exist
      if (passPhoto) formData.append("passPhoto", passPhoto);
      if (document1) formData.append("document1", document1);
      // if (document2) formData.append("document2", document2);
      // if (document3) formData.append("document3", document3);
  
      // Debugging: Verify FormData before sending
      console.log("FormData being sent:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]); // Log key-value pairs
      }
  
      const response = await fetch(
        `${baseUrl}/api/admission/update/studentDocuments/${studentId}/${oId}`,
        {
          method: "PUT",
          body: formData, // No need to set Content-Type, it is set automatically
        }
      );
  
      if (response.ok) {
        console.log("✅ Files uploaded and data updated successfully");
        setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
        fetchData(); // Refresh the data
        // toast.success("Files uploaded and data updated!", { position: "top-right", autoClose: 1000 });
      } else {
        console.error("❌ Failed to upload files and update data");
        const errorText = await response.text();
        console.error("Response Error:", errorText);
        // toast.error("Failed to upload files", { position: "top-right", autoClose: 1000 });
      }
    } catch (error) {
      console.error("❌ Error:", error);
      toast.error("Error uploading files", { position: "top-right", autoClose: 1000 });
    }
  };
  
  
  
  

  const handleEditClick = () => {
    setIsEditing((prev) => ({ ...prev, [tabIndex]: true }));
  };

  const handleCancelClick = () => {
    setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
    setTabData((prevData) => ({ ...prevData, [tabIndex]: student }));
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };


  // Function to format field names with each word's first letter capitalized
  // const formatFieldName = (field) => {
  //   return field
  //     .replace(/([A-Z])/g, ' $1')  // Insert space before capital letters
  //     .replace(/^./, str => str.toUpperCase())  // Capitalize the first letter of the entire string
  //     .replace(/\b\w/g, char => char.toUpperCase());  // Capitalize the first letter of each word
  // };

  const formatFieldName = (field) => {
    const fieldMap = {
      romanNumberClass: "Class", // Change 'romanNumberClass' to 'Class'
      dateofBirth: "Date of Birth",
      emailId: "Email ID",
      contactNumber1: "Contact Number",
      hno: "House Number",
      uan: "UAN",
      ifscCode: "IFSC Code",
    };
  
    // If field exists in fieldMap, return the mapped value
    if (fieldMap[field]) {
      return fieldMap[field];
    }
  
    // Default behavior: format field name with spacing & capitalization
    return field
      .replace(/([A-Z])/g, " $1") // Insert space before capital letters
      .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter of string
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  };
  

  return (
    <Box margin={2}>
      {/* {loader ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        employee && ( */}
          <Card sx={{ backgroundColor: 'white', boxShadow: 1, marginTop: 12 }}>
            <CardContent>
            
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={4}>
              
                <Box display="flex" alignItems="center">
                <ArrowBackIcon
                style={{
                  // marginRight: isMobile ? 0 : 15, // Adjust margin on mobile and desktop
                  fontSize: "25px", // Adjust size as needed
                  cursor:'pointer',
                  marginBottom:"1%"
                }}

                onClick={() => navigate(-1)}
              />
              {/* Profile PIc AND Employee Name  */}
                  <Avatar
                    alt={`${student.firstName} ${student.lastName}`}
                    src={`data:image/jpeg;base64,${student.passPhoto}`}
                    sx={{ width: 70, height: 70}}
                  />
                  <Box sx={{ ml:1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: 22 }}>
                      {student.firstName} {student.lastName}
                    </Typography>
                    <Typography variant="h5" sx={{ fontSize: 15 }}>
                      {student.studentId}
                    </Typography>
                  </Box>
                </Box>

                {/* <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#3C3972" },
                    fontWeight: "bold",
                  }}
                  onClick={() => navigate(`/attendance/${empId}`)}
                >
                  View Attendance
                </Button> */}
              </Box>

              <Tabs value={tabIndex} onChange={handleTabChange} aria-label="student details tabs">
                <Tab label="Personal Information" sx={{ fontWeight: 'bold' }}  />
                <Tab label="Parent Details" sx={{ fontWeight: 'bold' }}  />
                <Tab label="Educational Background" sx={{ fontWeight: 'bold' }} />
                <Tab label="Admission Details" sx={{ fontWeight: 'bold' }} />
                <Tab label="Fee Details" sx={{ fontWeight: 'bold' }} />
                
                <Tab label="Other Details" sx={{ fontWeight: 'bold' }} />
              </Tabs>

              <Grid container spacing={2} mt={2}>
                {tabIndex === 0 && (
                  <>
                    
{[
  "firstName", "lastName", "gender", "dateofBirth",
  "aadharNumber", "address", "primaryContact",
  "alternateContact", "nationality", "religion", "caste",
].map((field) => {
  const rawValue = tabData[tabIndex][field] || "";

  // ✅ Robust date string to Date object converter
  const getDateObjFromString = (str) => {
    if (!str) return null;

    // Format: "yyyyMMdd"
    if (/^\d{8}$/.test(str)) {
      const yyyy = str.slice(0, 4);
      const mm = str.slice(4, 6);
      const dd = str.slice(6, 8);
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    // Format: "dd-MM-yyyy"
    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) {
      const [dd, mm, yyyy] = str.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`);
    }

    // Format: "yyyy-MM-dd"
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      return new Date(str);
    }

  


    return null;
  };

  const displayValue =
    field === "dateofBirth" && rawValue.length === 8
      ? `${rawValue.slice(0, 4)}-${rawValue.slice(4, 6)}-${rawValue.slice(6, 8)}`
      : rawValue || "N/A";

          // ✅ Only letters for first & last name
  const handleNameInput = (e) => {
    const { name, value } = e.target;
    // Allow only letters & spaces
    if (/^[A-Za-z\s]*$/.test(value)) {
      handleChange(e); // your existing change handler
    }
  };

  // ✅ Phone number handling
  const handleNumberInput = (e) => {
    const { name, value } = e.target;
    if (name === "primaryContact" || name === "alternateContact") {
      if (!value.startsWith("91")) return;
      const afterPrefix = value.slice(2);
      if (/^\d*$/.test(afterPrefix) && value.length <= 12) {
        handleChange(e);
      }
    } else {
      handleChange(e);
    }
  };
    const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

// ✅ Aadhaar number handling – only digits & max 12
  const handleAadharInput = (e) => {
    const { value } = e.target;
    if (/^\d{0,12}$/.test(value)) {
      handleChange(e);
    }
  };

  // ✅ Handle DatePicker change
  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const formatted = format(date, "yyyyMMdd"); // always store as "yyyyMMdd"
      setTabData((prev) => ({
        ...prev,
        [tabIndex]: {
          ...prev[tabIndex],
          dateofBirth: formatted,
        },
      }));
    }
  };

  return (
    <Grid item xs={12} sm={6} key={field}>
      <Box mb={2}>
        <Typography
          fullWidth
          sx={{
            fontSize: 16,
            backgroundColor: "#dcf5f4",
            padding: 2,
          }}
        >
          <strong>{formatFieldName(field)}:</strong>{" "}
          {isEditing[tabIndex] ? (
            field === "dateofBirth" ? (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Date of Birth"
                  value={getDateObjFromString(rawValue)}
                  onChange={handleDateChange}
                  format="yyyy/MM/dd"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      sx: {
                        backgroundColor: "#dcf5f4",
                        marginTop: "4px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            ) : field === "gender" ? (
              <TextField
                select
                name={field}
                value={rawValue}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
              >
                {genderOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            ) : 
            (
              <TextField
                name={field}
                type="text"
                value={
                  field === "primaryContact" || field === "alternateContact"
                    ? rawValue.startsWith("91")
                      ? rawValue
                      : rawValue
                      ? "91" + rawValue
                      : "91"
                    : rawValue
                }
                onChange={
                  field === "primaryContact" || field === "alternateContact"
                    ? handleNumberInput
                    : field === "firstName" || field === "lastName" ||
                    field === "nationality" ||
                      field === "religion" ||
                      field === "caste"
                    ? handleNameInput
                    : field === "aadharNumber"
                    ? handleAadharInput
                    : handleChange
                }
                variant="outlined"
                size="small"
                fullWidth
                 inputProps={
                  field === "aadharNumber" ? { maxLength: 12 } : {}
                }
              />
            )
          ) : (
            displayValue
          )}
        </Typography>
      </Box>
    </Grid>
  );
})}
                  </>
                )}

                {tabIndex === 1 && (
                <>
                  {[
                    "fathersFirstName",
                    "fathersLastName",
                    "fathersQualification",
                    "fathersOccupation",
                    "fathersMailId",
                    "mothersFirstName",
                    "mothersLastName",
                    "mothersQualification",
                    "mothersOccupation",
                    "mothersMailId",
                  ].map((field) => {
                    const rawValue = tabData[tabIndex]?.[field] || "";

                    // Letters-only handler
                    const handleTextOnlyInput = (e) => {
                      const { name, value } = e.target;
                      if (/^[A-Za-z\s]*$/.test(value)) {
                        handleChange(e);
                      }
                    };

                    return (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                          <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: "#dcf5f4",
                              padding: 2,
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{" "}
                            {isEditing[tabIndex] ? (
                              <TextField
                                name={field}
                                type="text"
                                value={rawValue}
                                onChange={
                                  field === "fathersMailId" || field === "mothersMailId"
                                    ? handleChange // allow normal typing for emails
                                    : handleTextOnlyInput // letters-only for other fields
                                }
                                variant="outlined"
                                size="small"
                                fullWidth
                              />
                            ) : (
                              rawValue || "N/A"
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    );
                  })}
                </>
                )}


            {tabIndex === 2 && (
  <>
    {/* Educational Background */}
    {[
      'previousSchool',
      'course',
      'romanNumberClass',
      'sections',
      'mole1',
      'mole2',
    ]
      .filter((field) => {
        if (field === 'course' && board !== 'INTERMEDIATE') {
          return false; // Skip 'course' if board is not INTERMEDIATE
        }
        return true;
      })
      .map((field) => (
        <Grid item xs={12} sm={6} key={field}>
          <Box mb={2}>
            <Typography
              sx={{
                fontSize: 16,
                backgroundColor: '#dcf5f4',
                padding: 2,
              }}
            >
              <strong>{formatFieldName(field)}:</strong>{' '}

              {isEditing[tabIndex] ? (
                field === 'sections' ? (
                  <TextField
                    name={field}
                    value={tabData[tabIndex][field] || ''}
                    onChange={(e) => {
                      // Allow letters, spaces, and special characters for sections
                      const validValue = e.target.value.replace(/[^a-zA-Z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g, '');
                      handleChange({ target: { name: field, value: validValue } });
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                ) : ['previousSchool', 'mole1', 'mole2'].includes(field) ? (
                  <TextField
                    name={field}
                    value={tabData[tabIndex][field] || ''}
                    onChange={(e) => {
                      // Only letters and spaces allowed
                      const lettersOnly = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                      handleChange({ target: { name: field, value: lettersOnly } });
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                ) : field !== 'romanNumberClass' ? (
                  <TextField
                    name={field}
                    value={tabData[tabIndex][field] || ''}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                ) : (
                  tabData[tabIndex][field] || 'N/A'
                )
              ) : (
                tabData[tabIndex][field] || 'N/A'
              )}
            </Typography>
          </Box>
        </Grid>
      ))}
  </>
)}





{tabIndex === 3 && (
  <>
    {/* Admission Details */}
    {[
      "studentId",
      "customAdmissionNumber",
      "studentJoinedYear",
      "studentJoinedClass",
      "studentRollNumber",
      "pen",
    ].map((field) => (
      <Grid item xs={12} sm={6} key={field}>
        <Box mb={2}>
          <Typography
            sx={{
              fontSize: 16,
              backgroundColor: "#dcf5f4",
              padding: 2,
            }}
          >
            <strong>{formatFieldName(field)}:</strong>{" "}
            {isEditing[tabIndex] && field !== "studentId" ? (
              field === "studentJoinedClass" ? (
                <TextField
                  select
                  name={field}
                  value={tabData[tabIndex][field] || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                >
                  {sscClassOptions.map((cls) => (
                    <MenuItem key={cls} value={cls}>
                      {cls}
                    </MenuItem>
                  ))}
                </TextField>
              ) : (
                <TextField
                  name={field}
                  value={tabData[tabIndex][field] || ""}
                  onChange={(e) => {
                    let value = e.target.value;
                    // Only allow numbers and special characters for specific fields
                    if (
                      ["customAdmissionNumber", "studentJoinedYear", "studentRollNumber","pen"].includes(field)
                    ) {
                      value = value.replace(/[a-zA-Z]/g, "");
                    }
                    tabData[tabIndex][field] = value;
                    handleChange({ target: { name: field, value } });
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )
            ) 
            : 
            (
              tabData[tabIndex][field]
            )}
          </Typography>
        </Box>
      </Grid>
    ))}
  </>
)}
                
                {tabIndex === 4 && (
  <>
    {/* Admission Details */}
    {['tutionFee', 'admissionFee'].map((field) => (
      <Grid item xs={12} sm={6} key={field}>
        <Box mb={2}>
          <Typography
            sx={{
              fontSize: 16,
              backgroundColor: '#dcf5f4',
              padding: 2
            }}
          >
            <strong>{formatFieldName(field)}:</strong>{' '}
            {isEditing[tabIndex] ? (
              <TextField
                name={field}
                value={tabData[tabIndex][field] || ''}
                onChange={(e) => {
                  // Allow only numbers
                  const value = e.target.value.replace(/\D/g, '');
                  tabData[tabIndex][field] = value;
                  handleChange({ target: { name: field, value } });
                }}
                variant="outlined"
                size="small"
                fullWidth
              />
            ) : (
              tabData[tabIndex][field]
            )}
          </Typography>
        </Box>
      </Grid>
    ))}
  </>
)}

                

                {tabIndex === 5 && (
                  <>
                    {/* Other Details Tab */}
                    {['passPhoto',].map((field) => (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                          <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: '#dcf5f4',
                              padding: 2,
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{' '}
                            {isEditing[tabIndex] ? (
                              <Input
                                type="file"
                                name={field}
                                onChange={handleFileChange}
                                fullWidth
                              />
                            ) : (
                              // tabData[tabIndex][field] && tabData[tabIndex][field].name 
                              //   ? tabData[tabIndex][field].name 
                              //   : 'No file uploaded'
                              field === 'passPhoto' && tabData[tabIndex][field]
                                  ? <Avatar src={`data:image/jpeg;base64,${student.passPhoto}`} sx={{ width: 120, height: 120 }} />
                                  : 'No file uploaded'
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </>
                )}

                




              </Grid>

              <Box mt={2}>
  {isEditing[tabIndex] ? (
    <>
      <Button
        variant="contained"
        sx={{
          color: "#fff",
          backgroundColor: "#3C3972",
          mr: 2,
          "&:hover": { backgroundColor: "#3C3972" },
        }}
        onClick={handleSave}
        disabled={buttonLoader} // Disable button while loading
      >
        {buttonLoader ? (
          <CircularProgress size={24} sx={{ color: "#fff" }} />
        ) : (
          "Save"
        )}
      </Button>

      <Button onClick={handleCancelClick} variant="outlined" ml="10px">
        Cancel
      </Button>
    </>
  ) : (
    // Hide Edit Button when tabIndex is 4 (Admission Details)
    // tabIndex !== 3 && (
      <Button
        onClick={handleEditClick}
        sx={{
          color: "#fff",
          backgroundColor: "#3C3972",
          "&:hover": { backgroundColor: "#3C3972" },
        }}
        variant="contained"
      >
        Edit
      </Button>
    // )
  )}
</Box>

            </CardContent>
          </Card>
        {/* )
      )} */}
      <ToastContainer />
    </Box>
  );
}

export default StudentUpdateDetails;